import util from '@bmp-vue/core/api/util'

let controller = 'Parceiro'
export default Object.assign({}, util.GetCrud(controller, null), {  
  GetParceiroParametrizacao: function () {
    return util.Axios.GetAll(controller + '/InternetBankingHabilitado')
  },
})
